module.exports = __webpack_public_path__ + "img/logo_collapse.da7917a8.svg";